import { cn } from '@/lib/utils';
import type { ChatMessage } from '@/types/support';

function formatTime(ts: number) {
  return new Date(ts).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export function MessageBubble({
  message,
  isOwn,
}: {
  message: ChatMessage;
  isOwn: boolean;
}) {
  if (message.type === 'system' || message.senderRole === 'system') {
    return (
      <div className="flex justify-center py-1">
        <span className="text-[11px] text-muted-foreground bg-muted/60 px-2.5 py-1 rounded-full">
          {message.text}
        </span>
      </div>
    );
  }

  return (
    <div className={cn('flex', isOwn ? 'justify-end' : 'justify-start')}>
      <div className={cn('flex flex-col max-w-[85%]', isOwn ? 'items-end' : 'items-start')}>
        <div
          className={cn(
            'px-3.5 py-2.5 text-[13px] leading-relaxed shadow-sm whitespace-pre-wrap break-words',
            isOwn
              ? 'bg-foreground text-background rounded-2xl rounded-br-sm'
              : 'bg-slate-100 dark:bg-white/[0.06] text-foreground rounded-2xl rounded-bl-sm',
          )}
        >
          {message.text}
        </div>
        <span className="mt-1 px-1 text-[10px] text-muted-foreground/70 flex items-center gap-1">
          {formatTime(message.createdAt)}
          {isOwn && message.read && <span>· Read</span>}
          {isOwn && !message.read && message.delivered && <span>· Delivered</span>}
        </span>
      </div>
    </div>
  );
}
